import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material"
import { Newspaper, LocalLibrary } from "@mui/icons-material"
import { useNavigate, useLocation } from "react-router-dom"

const drawerWidth = 240

const sidebarItems = [
  { id: "career", label: "Career", icon: Newspaper, path: "career" },
  { id: "management", label: "Learning Managment", icon: LocalLibrary, path: "learningManagement" },
]

export default function ContentSidebar({ activeSection }) {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <Box
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        borderRight: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <div className="p-3">
        <Typography variant="h6">HR Content</Typography>
      </div>
      <List>
        {sidebarItems.map((item) => (
          <ListItem key={item.id} disablePadding>
            <ListItemButton
              selected={activeSection === item.id}
              onClick={() => {
                navigate(item.path, { state: location.state })
              }}
            >
              <ListItemIcon>
                <item.icon />
              </ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  )
}

